import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const relTime = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  const diff = Math.max(0, Date.now() - d.getTime());
  const h = Math.floor(diff / 3_600_000);
  if (h < 1) return "moments ago";
  if (h < 24) return `${h} hour${h > 1 ? "s" : ""} ago`;
  const days = Math.floor(h / 24);
  return `${days} day${days > 1 ? "s" : ""} ago`;
};

const ActivityTicker = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/public/activity`)
      .then((r) => !cancelled && setData(r.data))
      .catch(() => !cancelled && setData(null));
    return () => {
      cancelled = true;
    };
  }, []);

  if (!data || (data.subscribers_total === 0 && data.messages_week === 0))
    return null;

  const items = [
    {
      n: data.subscribers_total,
      label: "subscribers, all-time",
    },
    {
      n: data.subscribers_week,
      label: "joined this week",
    },
    {
      n: data.messages_week,
      label: "messages this week",
    },
  ].filter((i) => i.n > 0);

  if (items.length === 0) return null;

  return (
    <section
      data-testid="section-activity"
      className="bg-[#F7F7F4] border-y border-[#E7E7E2]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 md:py-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <div className="overline">— Live from the studio</div>
            <h3 className="mt-3 font-sora text-[20px] md:text-[22px] font-semibold text-[#111111] tracking-tight">
              Real numbers, updated automatically.
            </h3>
          </div>
          {data.last_subscriber_at && (
            <div className="font-mono text-[11px] tracking-[0.16em] uppercase text-[#111111]/55">
              Last signup · {relTime(data.last_subscriber_at)}
            </div>
          )}
        </div>

        <dl className="mt-7 grid grid-cols-1 sm:grid-cols-3 gap-px bg-[#E7E7E2] border border-[#E7E7E2] rounded-xl overflow-hidden">
          {items.map((it) => (
            <div
              key={it.label}
              data-testid={`activity-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-white px-6 py-5"
            >
              <dt className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#111111]/45">
                {it.label}
              </dt>
              <dd className="mt-2 font-sora text-[32px] md:text-[36px] font-extrabold tracking-tight text-[#111111] leading-none">
                {it.n}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
};

export default ActivityTicker;
